import React, { useState } from "react";
import { PuntoVentaABM } from "./PuntoVenta/PuntoVentaABM";
import { PuntoVentaListado } from "./PuntoVenta/PuntoVentaListado";
import { type PuntoVenta } from "@/lib/api";
import { useRegisterOpcionesAbmNav } from "./opcionesAbmBreadcrumb";

type PVView = "ABM" | "Listado";

export function PuntoVentaSection() {
  const [currentView, setCurrentView] = useState<PVView>("Listado");
  const [selectedItem, setSelectedItem] = useState<PuntoVenta | null>(null);

  const handleEdit = (item: PuntoVenta) => {
    setSelectedItem(item);
    setCurrentView("ABM");
  };

  const handleBack = () => {
    setSelectedItem(null);
    setCurrentView("Listado");
  };

  const handleNew = () => {
    setSelectedItem(null);
    setCurrentView("ABM");
  };

  useRegisterOpcionesAbmNav(
    currentView === "ABM",
    selectedItem != null,
    handleBack
  );

  return (
    <div className="space-y-4">
      {currentView === "ABM" ? (
        <PuntoVentaABM
          selectedItem={selectedItem}
          onBack={handleBack}
          onSaved={handleBack}
        />
      ) : (
        <PuntoVentaListado onEdit={handleEdit} onNew={handleNew} />
      )}
    </div>
  );
}